var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.toggleTsDetail
      ? _c(
          "div",
          { staticClass: "card-inside-card" },
          [
            _c("card-list-builder", {
              attrs: {
                "use-new-version": true,
                items: _vm.items,
                fields: _vm.defaultFields,
                "has-badge": true,
                "is-badge-use-props": true,
                "badge-class": "statusClass",
                "hide-status": false,
                "badge-value": "validatedStatus",
                "toggle-mode": true,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "encodedBy",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(item.encoder.name) +
                            " " +
                            _vm._s(item.encoder.firstName) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "val",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn bg-transparent border-0 pr-0",
                            attrs: { size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.validateItem(item.id)
                              },
                            },
                          },
                          [
                            _c(_vm.getLucideIcon(_vm.ICONS.CHECK_SQUARE.name), {
                              tag: "component",
                              attrs: {
                                color: _vm.ICONS.CHECK_SQUARE.color,
                                size: 20,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "actions",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn bg-transparent border-0 ml-1",
                            attrs: { size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.rowEdit(item)
                              },
                            },
                          },
                          [
                            _c(_vm.getLucideIcon(_vm.ICONS.EDIT.name), {
                              tag: "component",
                              attrs: { color: _vm.ICONS.EDIT.color, size: 20 },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1878763379
              ),
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }